// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2lt1R","itemTitle":"ClientEmergencyInfo_itemTitle__3wMPk","itemText":"ClientEmergencyInfo_itemText__hnZ0L"};